import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './app/router'
import { applyMotionPreference } from './app/motion'
import { progressRepository } from './persistence/progressRepository'
import './styles/global.css'

// Apply the stored motion preference before first paint, and keep it in sync
// with the OS setting for learners who chose "Match my system".
applyMotionPreference(progressRepository.load().preferences.reducedMotion)
window
  .matchMedia?.('(prefers-reduced-motion: reduce)')
  ?.addEventListener?.('change', () =>
    applyMotionPreference(progressRepository.load().preferences.reducedMotion),
  )

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found in index.html')
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
